declare global {
	let logg: Logg;
}

type LoggType = 'D' | 'E' | 'I' | 'L' | 'W';

interface LoggEntry {
	date: string;
	type: LoggType;
	message: string;
	data: any[];
}

export class Logg {
	private readonly out_console = true;
	private readonly out_dom = false;
	private readonly out_history = true;

	private dom_root: JQuery | null = null;

	private history: LoggEntry[] = [];

	public constructor() {
		jQuery(document).ready(() => {
			this.dom_root = jQuery('#gpsh-logg');
			jQuery('#gpsh-logg-upload').on('click', () => {
				this.upload();
			});
		});

		// Allow Error to be serialized
		if (!('toJSON' in Error.prototype)) {
			Object.defineProperty(Error.prototype, 'toJSON', {
				value: function () {
					let clone: any = {};
					Object.getOwnPropertyNames(this).forEach((key) => (clone[key] = this[key]));
					return clone;
				},
				configurable: true,
				writable: true
			});
		}
	}

	public debug = (message?: any, ...optionalParams: any[]) => {
		this.append(console.debug, 'D', message, optionalParams);
	};

	public error = (message?: any, ...optionalParams: any[]) => {
		this.append(console.error, 'E', message, optionalParams);
	};

	public info = (message?: any, ...optionalParams: any[]) => {
		this.append(console.info, 'I', message, optionalParams);
	};

	public log = (message?: any, ...optionalParams: any[]) => {
		this.append(console.log, 'L', message, optionalParams);
	};

	public warn = (message?: any, ...optionalParams: any[]) => {
		this.append(console.warn, 'W', message, optionalParams);
	};

	public getRecentLog = () => {
		// Keep the most recent lines; stays under banyan's cap and Datadog's ~256KB line limit.
		const MAX_CHARS = 240 * 1024;
		let upload = '';
		for (let i = this.history.length - 1; i >= 0; i--) {
			let entry = this.history[i];
			let line = entry.type + ' ' + entry.date + ' ' + entry.message + ' ' + Logg.stringify(entry.data) + '\n';
			if (upload.length + line.length > MAX_CHARS) {
				break;
			}
			upload = line + upload;
		}
		return upload;
	};

	public upload = () => {
		try {
			beech?.server?.sendClientLog('manual');
			jQuery('#gpsh-logg-report').text('Report sent — thanks.');
		} catch (e) {
			console.error('logg >> upload failed', e);
			jQuery('#gpsh-logg-report').text('Could not send report.');
		}
	};

	private append(fn: (message: any, ...data: any[]) => void, type: LoggType, message: any, data: any[]) {
		if (this.out_console) {
			fn.apply(this, [message, ...data]);
		}

		if (this.out_history) {
			this.history.push({
				date: new Date().toISOString(),
				type: type,
				message: message,
				data: data.map((item) => (typeof item === 'object' ? jQuery.extend({}, item) : item))
			});
		}

		if (this.out_dom && this.dom_root) {
			let dataString = Logg.stringify(data);
			let dataHtml = dataString ? '<br><small>' + dataString + '</small>' : '';

			this.dom_root.append(
				'<div>' + '<strong>' + type + '</strong>' + '<span>' + message + '</span>' + dataHtml + '</div>'
			);
		}
	}

	private static stringify(data: any[]) {
		return data
			.map((item) => {
				try {
					return JSON.stringify(item);
				} catch (e) {
					return typeof item;
				}
			})
			.join(' ');
	}
}
